import { instances as spinbuttonInstances } from '../spinbutton';

const elements = {
	button: document.querySelector('.js-submit'),
	element: document.querySelector('.js-product-form'),
	originalPrice: document.querySelector('.js-original-price'),
	price: document.querySelector('.js-price'),
	qty: document.querySelector('.js-qty'),
	saving: document.querySelector('.js-saving'),
	status: document.querySelector('.js-status'),
	color: document.querySelector('.js-product-color'),
	size: document.querySelector('.js-product-size'),
};

let formElement = document.querySelector('.js-product-form');
let sizeInputs = document.querySelector('.js-input-size');

init();

function init() {
	if (!elements.element) {
		return;
	}

	let selectedVariant;
	let matchedOptions = 0;

	formElement.addEventListener('submit', function(event) {
		if (!selectedVariant && matchedOptions > 0) {
			event.preventDefault();
			let notice = document.querySelector('.js-product-notice');
			notice.classList.add('is-active');
		}
	});

	formElement.addEventListener('variantChange', event => {
		if (event.detail.length == 0) {
			// variant not available
			selectedVariant = undefined;
			matchedOptions = 1;

			elements.button.disabled = true;
			elements.button.innerText = 'Unavailable';
			elements.status.innerText = 'Unavailable';
		} else if (event.detail.length > 1) {
			selectedVariant = undefined;
			matchedOptions = 1;
			elements.button.disabled = true;
		} else {
			selectedVariant = event.detail[0];
			matchedOptions = 1;

			let price = selectedVariant.price;
			let originalPrice = selectedVariant.originalPrice;
			let saving = selectedVariant.saving;
			let color = selectedVariant.color ? selectedVariant.color.title : undefined;
			let outOfStock = selectedVariant.oos !== false;
			let size = sizeInputs.options[sizeInputs.selectedIndex].text;

			let onSale = selectedVariant.onSale !== false;

			spinbuttonInstances[elements.qty.id].setMin(selectedVariant.minQty);
			spinbuttonInstances[elements.qty.id].setMax(selectedVariant.maxQty);

			elements.price.innerText = price;
			elements.originalPrice.innerText = originalPrice;
			elements.saving.innerText = `Save ${saving}`;
			if (elements.color) elements.color.innerText = `Colour: ${color}`;
			if (elements.size) elements.size.innerText = `Size: ${size}`;

			elements.button.disabled = outOfStock;
			elements.button.innerText = outOfStock ? 'Unavailable' : 'Add to basket';
			elements.status.innerText = outOfStock ? 'Out of Stock' : 'Currently in stock';

			elements.saving.hidden = !onSale;
			elements.originalPrice.hidden = !onSale;
			elements.originalPrice.classList.toggle('u-strike-through', onSale);
		}
	});
}
